export default __webpack_public_path__ + "static/media/blueBall.f08fb7c8.svg";